export enum CustomerStatus {
  deactivated = 0,
  active = 1
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/customer-status.ts